import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction } from '../../serviceCall'

export const createComposeRecordingApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    formDataCommonFunction(data,apiConstants.VIDEO.CREATE_COMPOSE_RECORDING)
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
